import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Carousel } from 'antd/es';

import BounceLoader from '@common/react/components/UI/Loaders/BounceLoader';

import LinkMore from '@app/components/UI/LinkMore/LinkMore';
import SliderButtons from '@app/components/UI/SliderButtons/SliderButtons';
import CustomAvatar from '@app/components/UI/CustomAvatar/CustomAvatar';
import ModalAreaVet from '@app/components/UI/ModalAreaVet/ModalAreaVet';
import { SliderVetProps } from '@app/components/UI/Slider/SliderVet';
import { useIsMobile } from '@app/hooks/useIsMobile';
import { Veterinarian } from '@app/objects/Veterinarian';

const arrowIcon = require('@app/images/arrow_circle.svg');

const SliderVetCarousel: React.FC<SliderVetProps> = (props) => {
	const slider = React.useRef<any>();
	const isMobile = useIsMobile();
	const [currentIndex, setCurrentIndex] = React.useState(0);
	const [slidesToShow, setSlidesToShow] = React.useState(1);
	const [items, setItems] = React.useState<Array<Veterinarian>>(props.items);
	const [currentVet, setCurrentVet] = React.useState<Veterinarian>(props.items[0]);
	const [visible, setVisible] = React.useState<boolean>(false);

	React.useEffect(() => {
		props.items.length < 3 ? setItems(props.items) : setItems(props.items.concat(props.items));
	}, [props.items]);

	React.useEffect(() => {
		items.length >= 3 ? setSlidesToShow(3) : setSlidesToShow(1);
	}, [items]);

	React.useEffect(() => {
		setCurrentVet(items[currentIndex]);
	}, [items, currentIndex]);

	React.useEffect(() => {
		if (isMobile) {
			props.items.length !== 1 ? setItems(props.items.concat(props.items)) : setItems(props.items);
			props.items.length !== 1 ? setSlidesToShow(3) : setSlidesToShow(1);
		} else {
			items.length >= 3 ? setSlidesToShow(3) : setSlidesToShow(1);
			props.items.length < 3 ? setItems(props.items) : setItems(props.items.concat(props.items));
		}
	}, [isMobile]);

	return !props.loading ? (
		<>
			<div className="slider-vet-body__left">
				<article className="vet-block">
					{currentVet && (
						<>
							<header className="vet-block-header">
								<CustomAvatar
									className="vet-block-header__img"
									src={currentVet.avatar}
									alt={`Dr. ${currentVet.firstName}`}
									maxWidth={325}
								/>
								<div>
									<h4 className="vet-block-header__name">{`Dr. ${currentVet.firstName}`}</h4>
									<p className="vet-block-header__location">
										{props.teleadviceCapture ? props.teleadviceCapture : currentVet.areaName}
									</p>
								</div>
							</header>
							<div className="vet-block__text" dangerouslySetInnerHTML={{ __html: currentVet.biography }} />
							{!props.hideReadMore && currentVet.areaUrl ? (
								<LinkMore
									linkMoreCaption="Read more"
									linkMoreHref={`/find-a-vet/${currentVet.area.state?.replace(' ', '-')}/${currentVet.areaUrl}/veterinarians`}
									linkMoreState={{ currentVetId: currentVet.id }}
								/>
							) : (
								<Button
									className="link-more slider-vet-btn"
									onClick={() => {
										setVisible(true);
									}}
								>
									<span>Read more</span>
									<img src={arrowIcon} alt="arrow" className="link-more-img" />
								</Button>
							)}
							<ModalAreaVet vet={currentVet} visible={visible} onOk={() => setVisible(false)} onCancel={() => setVisible(false)} />
						</>
					)}
				</article>
			</div>
			<div className={props.items.length !== 1 ? 'slider-vet-body__right' : 'slider-vet-body__right slider-vet-body__right_single'}>
				<Carousel
					ref={slider}
					initialSlide={currentIndex}
					slidesToShow={slidesToShow}
					beforeChange={(currentSlide, nextSlide) => setCurrentIndex(nextSlide)}
					dots={false}
					infinite
					swipeEvent={(swipeDirection) => (swipeDirection === 'left' ? slider.current.next() : slider.current.prev())}
				>
					{items.map((item: Veterinarian) => {
						return item.areaUrl ? (
							<Link
								to={{
									pathname: `/find-a-vet/${item.area.state?.replace(' ', '-')}/${item.areaUrl}/veterinarians`,
								}}
								key={item.id}
								state={{ currentVetId: item.id }}
							>
								<CustomAvatar
									key={item.id}
									className={slidesToShow >= 3 ? 'slider-vet-item' : 'slider-vet-item slider-vet-item_color'}
									alt="Doctor"
									src={item.avatar}
									maxWidth={325}
								/>
							</Link>
						) : (
							<CustomAvatar
								key={item.id}
								className={slidesToShow >= 3 ? 'slider-vet-item' : 'slider-vet-item slider-vet-item_color'}
								alt="Doctor"
								src={item.avatar}
								maxWidth={325}
							/>
						);
					})}
				</Carousel>
				{slidesToShow >= 3 ? <SliderButtons slider={slider} /> : null}
			</div>
		</>
	) : <BounceLoader />;
};

export default SliderVetCarousel;
